import React from 'react';

import { Icon, useSettings } from 'app/main/components';
import { DetailsSectionWrapper, ViewList } from 'app/main/components/page-layouts';
import FilterExternalListItem from 'app/main/components/filter/filter-saved/FilterExternalListItem';

export default function UsersDetailsSectionFiltersSaved(props) {
	const { t } = useSettings();

	const [refresh, setRefresh] = React.useState(true);
	const updateRefresh = () => setRefresh(!refresh);

	return (
		<DetailsSectionWrapper
			avatar={<Icon icon="account-filter" />}
			title={t('USERS_SAVEDFILTERS_SECTION')}
			subheader={t('USERS_SAVEDFILTERS_SUBHEADER')}
			disablePadding
		>
			<ViewList
				module="sys_filters_saved"
				itemLayout={FilterExternalListItem}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{
						filt_field: 'filt_user_uid',
						filt_clause: 'equals',
						filt_value: props.userUid
					}
				]}
				showFilters={false}
				showExportButton={false}
			/>
		</DetailsSectionWrapper>
	);
}
